module.exports = __webpack_public_path__ + "img/complete.89c0b128.webp";